import React, { useState, memo } from 'react';
import { CheckCircle2, ChevronDown, ChevronUp } from 'lucide-react';
export function ProductShowcase() {
  const [openTomo, setOpenTomo] = useState<number | null>(null);
  const tomos = [{
    id: 'T1',
    icon: '📘',
    title: 'TOMO 1 — Seguridad Eléctrica y Oficio Técnico',
    desc: 'La base que todo alumno de taller debe tener antes de tocar un cable. Efectos de la corriente eléctrica en el cuerpo humano (umbrales de percepción, tetanización y fibrilación). EPP específicos para trabajos eléctricos según normas IRAM. Uso correcto y seguro de herramientas manuales y de medición: multímetro, pinza amperométrica y telurímetro. Procedimientos de bloqueo y señalización de tableros (LOTO). Primeros auxilios ante accidente eléctrico.',
    ficha: '✅ Incluye ficha práctica: "Checklist de habilitación del alumno al tablero" — el docente firma cuando el alumno demuestra que es seguro dejarlo operar.'
  }, {
    id: 'T2',
    icon: '📗',
    title: 'TOMO 2 — Canalizaciones y Conductores',
    desc: 'Del catálogo al taller: qué se compra, cómo se instala, cómo se evalúa. Tipos de cañerías: PVC rígido, flexible corrugado liviano y pesado, bandeja portacables y cablecanal. Técnicas de doblado en frío y fijación de cañería. Cálculo de ocupación de cañerías según tabla de llenado (IEC/AEA). Código de colores según IRAM 2183 y tipos de conductores IRAM 247-3. Técnicas de empalme y conexionado en cajas de paso.',
    ficha: '✅ Incluye ficha práctica: "Guía paso a paso de montaje de cañería rígida con cajas" — el alumno la completa mientras trabaja.'
  }, {
    id: 'T3',
    icon: '📙',
    title: 'TOMO 3 — Circuitos de Iluminación y Tomas (Norma AEA 90364)',
    desc: 'El tomo que más van a usar tus alumnos en la vida real. Circuitos de Iluminación de Uso General (IUG) y Tomas de Uso General (TUG). Grados de electrificación de viviendas según metros cuadrados. Puntos mínimos de utilización por ambiente. Disposición de bocas en planos arquitectónicos. Simbología eléctrica normalizada IRAM. Conexionado de llaves de efecto simple, paralelo (conmutada) y cruzado.',
    ficha: '✅ Incluye ficha práctica: "Plano de vivienda tipo para trazado de bocas" — el alumno proyecta la instalación sobre un plano real.'
  }, {
    id: 'T4',
    icon: '📕',
    title: 'TOMO 4 — Tableros y Protecciones',
    desc: 'Donde el taller se vuelve ingeniería. Cálculo de corriente de diseño y elección de termomagnéticas (curvas B y C). Disyuntor diferencial: funcionamiento, sensibilidad (30mA / 300mA) y aplicación. Selectividad de protecciones en cascada. Puesta a Tierra (PAT): electrodo de dispersión tipo jabalina, resistencia de tierra y medición con telurímetro. Memoria de cálculo de carga instalada paso a paso.',
    ficha: '✅ Incluye ficha práctica: "Planilla de memoria de cálculo para tablero de una vivienda" — el alumno la completa y el docente corrige sobre criterios claros.'
  }, {
    id: 'T5',
    icon: '📓',
    title: 'TOMO 5 — Automatización y Circuitos Especiales',
    desc: 'La tecnología que el alumno va a instalar cuando egrese. Circuitos de Uso Especial (TUE): aires acondicionados, bombas de agua y hornos. Fotocontrol y sensor de movimiento: conexionado y regulación. Telerruptor y minutero: lógica de funcionamiento y casos de uso. Portero eléctrico: sistema de llamado, apertura y comunicación. Introducción a alarmas domiciliarias básicas.',
    ficha: '✅ Incluye ficha práctica: "Diagrama de conexión de bomba con flotante automático y protección diferencial"'
  }, {
    id: 'T6',
    icon: '📔',
    title: 'TOMO 6 — El Maletín del Docente',
    desc: 'La burocracia escolar, resuelta de una vez. Modelos de Planificación Anual editables para 3°, 4°, 5° y 6° año de técnica. Secuencias didácticas por unidad alineadas a los NAP vigentes. Rúbricas de evaluación de desempeño práctico en taller. Planillas de seguimiento de grupos y rotación en estaciones de trabajo. Banco de 60 preguntas para examen trimestral con sus respectivas respuestas modelo.',
    ficha: '✅ Incluye: "Guía de rotación de grupos en taller con 20 alumnos y 4 estaciones de trabajo simultáneas"'
  }];
  const includes = ['Explicaciones técnicas listas para enseñar sin adaptar', 'Ejemplos reales de instalaciones residenciales e industriales argentinas', 'Fichas de trabajo práctico listas para fotocopiar', 'Preguntas guía de cierre de clase', 'Evaluaciones completas con consignas claras', 'Rúbricas y criterios de corrección para taller', 'Secuencias didácticas listas por unidad', 'Adaptaciones para distintos años de cursada'];
  return <section className="py-10 md:py-16 px-4 bg-brand-card" data-id="element-179">
      <div className="max-w-4xl mx-auto" data-id="element-180">
        <div className="text-center mb-8" data-id="element-181">
          <h2 className="text-2xl md:text-4xl font-black text-white mb-2" data-id="element-182">
            🏆 KIT COMPLETO INSTALACIONES ELÉCTRICAS LISTAS
          </h2>
          <p className="text-lg md:text-xl font-bold text-brand-accent neon-glow" data-id="element-183">
            6 Tomos + 4 Bonos — Todo resuelto
          </p>
          <p className="text-sm md:text-base text-gray-500 mt-1 font-medium" data-id="element-184">
            +400 páginas listas para usar en el taller y en el aula
          </p>
        </div>

        <div className="text-center mb-6" data-id="element-185">
          <h3 className="text-xl font-black text-white inline-flex items-center bg-brand-accent px-4 py-1.5 rounded-lg" data-id="element-186">
            ⚡ 6 TOMOS COMPLETOS
          </h3>
          <p className="text-sm md:text-base font-bold text-gray-500 mt-2" data-id="element-187">
            Electrotecnia real aplicada al taller técnico
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mb-10" data-id="element-188">
          {tomos.map((tomo, i) => <div key={i} className="bg-brand-dark border border-white/10 rounded-xl overflow-hidden hover:border-brand-accent/30 transition-colors" data-id="element-189">
              <button onClick={() => setOpenTomo(openTomo === i ? null : i)} className="w-full p-4 md:p-5 text-left flex items-start justify-between focus:outline-none" data-id="element-190">
                <div className="flex items-start flex-1" data-id="element-191">
                  <span className="text-xl mr-2 leading-none shrink-0" data-id="element-192">
                    {tomo.icon}
                  </span>
                  <span className={`text-lg font-bold leading-tight ${openTomo === i ? 'text-brand-accent' : 'text-white'}`} data-id="element-193">
                    {tomo.title}
                  </span>
                </div>
                {openTomo === i ? <ChevronUp className="w-5 h-5 text-brand-accent shrink-0 ml-2" data-id="element-194" /> : <ChevronDown className="w-5 h-5 text-gray-600 shrink-0 ml-2" data-id="element-195" />}
              </button>

              <div className={`px-4 md:px-5 overflow-hidden transition-all duration-300 ease-in-out ${openTomo === i ? 'max-h-[800px] pb-4 opacity-100' : 'max-h-0 opacity-0'}`} data-id="element-196">
                <div className="border-t border-white/5 pt-3" data-id="element-197">
                  <p className="text-sm text-gray-400 leading-relaxed mb-3" data-id="element-198">
                    {tomo.desc}
                  </p>
                  <p className="text-sm text-brand-accent font-semibold" data-id="element-199">
                    {tomo.ficha}
                  </p>
                </div>
              </div>
            </div>)}
        </div>

        <div className="bg-brand-dark rounded-xl border border-white/10 overflow-hidden" data-id="element-200">
          <div className="bg-brand-accent py-3 px-4 text-center" data-id="element-201">
            <h4 className="text-lg md:text-xl font-bold text-white" data-id="element-202">
              ✅ CADA TOMO INCLUYE:
            </h4>
          </div>
          <div className="p-4 md:p-6" data-id="element-203">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-y-3 gap-x-6" data-id="element-204">
              {includes.map((item, i) => <div key={i} className="flex items-start" data-id="element-205">
                  <CheckCircle2 className="w-5 h-5 text-brand-accent mr-2.5 shrink-0" data-id="element-206" />
                  <span className="text-sm text-gray-300 font-medium" data-id="element-207">
                    {item}
                  </span>
                </div>)}
            </div>
          </div>
        </div>
      </div>
    </section>;
}